export default __webpack_public_path__ + "static/media/active.ad4eb840.svg";